import { EventbriteReconnectButton } from './EventbriteReconnectButton';
import { EventbriteServiceComponent } from './EventbriteServiceComponent';
export const EventbriteReconnectionConfig = {
  reconnectButton: EventbriteReconnectButton,
  serviceComponent: EventbriteServiceComponent
};